import Router from "../router";
import { store } from "../store/store";

const actionsScope = [
  "open-process",
  "send-process-report",
  "edit-process-start-time",
  "edit-process-end-time",
  "puede-cambiar-prioridad-op",
  "primero-selecciona-descripcion-y-luego-formato",
  "mostrar-certificaciones-en-modal-lote"
];

const scope = function () {
  // Get from vuex user
  const user = store.getters.user;
  const isSuperUser = user.SUPERUSER;

  let routerScope = [];
  if (isSuperUser) {
    console.log("Logged user is superuser");
    Router.options.routes[0].children.forEach((item) => {
      routerScope.push(item.name);
      if (item.children) {
        item.children.forEach((child) => {
          if (child.children) {
            child.children.forEach((grandChild) => {
              routerScope.push(grandChild.name);
            });
          }
          routerScope.push(child.name);
        });
      }
    });
    routerScope.push(...actionsScope);
  } else {
    routerScope = user.scope;
  }

  return routerScope;
};

export default scope;
